export const IDENTITIES_API_ENDPOINTS = {
  IDENTITIES: "/internal/identities",
  IDENTITIES_COUNTS: "/internal/identities/counts",
  REGENERATE_KYC_LINK: (id: string) => `/internal/identities/verification/${id}/kyc-link`,
  MAIL_SEND: "/internal/mail/send",
} as const;

/** Rows per request. The backend caps `limit` at 200. */
export const IDENTITIES_PAGE_SIZE = 24;

/**
 * Shortest term that is sent to the backend, which rejects anything shorter with a 400. Not arbitrary: the
 * search is backed by a `pg_trgm` index and there are no trigrams below 3 characters, so a 1-2 character term
 * would sequentially scan the whole table. The UI holds the request back and says so rather than firing a
 * query the server will refuse.
 */
export const IDENTITY_SEARCH_MIN_LENGTH = 3;

/** House standard for search debounce (same as clients, audit and cards). */
export const IDENTITY_SEARCH_DEBOUNCE_MS = 350;
